@if (pageReady) {
  <div class="side-panel-container">
    <div class="side-panel">
      <mat-card class="account-card" appearance="outlined">
        <mat-card-header class="account-header">
          <h2 class="account-title">{{ this.pageLabels.accountDetailHeaderText }}</h2>
        </mat-card-header>
        <mat-card-content class="account-content">
          <div class="account-detail-section">
            <p class="account-detail-label">{{ pageLabels.serviceAddressLabelText }}</p>
            <div class="account-detail-value">
              <p class="address-text">{{ panelData.Address | titlecase }}</p>
              <p class="address-text">{{ panelData.City }} {{ panelData.State }} {{ panelData.PostalCode }}</p>
            </div>
          </div>
          @if (panelData.PlanType != "") {
            <mat-divider></mat-divider>
            <div class="account-detail-section">
              <p class="account-detail-label">{{ pageLabels.ratePlanLabelText }}</p>
              <div class="account-detail-value">
                @if (panelData.ProductCode == "OPP") {
                  <p class="plan-text" [innerHTML]="panelData.PlanType"></p>
                  <p class="plan-text">{{ panelData.ContractLength }}</p>
                  <p class="plan-text">{{ panelData.PricePerTherm }}</p>
                }
                @if (panelData.ProductCode == "FIXED") {
                  <p class="plan-text" [innerHTML]="panelData.PlanType"></p>
                  <p class="plan-text">{{ panelData.ContractLength }}</p>
                  <p class="plan-text">{{ panelData.PricePerTherm }}</p>
                }
              </div>
            </div>
            @if (panelData.ProductCode == "FIXED") {
              <div class="account-detail-section">
                <p class="account-detail-label">{{ pageLabels.customerServiceFeeLabelText }}</p>
                <div class="account-detail-value">
                  <p class="plan-text">{{ panelData.CustomerServiceFee | currency }}</p>
                </div>
              </div>
            }
          }
        </mat-card-content>
      </mat-card>
    </div>
  </div>
}
